class CardCustomerModel {
    cardCustomerId?: number;
    customerCode?: string;
    customerName?: string;
    address?: string;
    droppingPointId?: number;
    droppingPointName?: string;
    unionId?:number;
    unionName?:string;
    customerPhoto?: string;
    panNumber?: string;
    mobileNumber?: string;
    aadharNumber?: string;
    rationcardNumber?: string
}
export default CardCustomerModel;
